import { format, isAfter, isBefore, isEqual, parse } from 'date-fns';

export const dateInRangeCompare = ({
  dateStart,
  dateEnd,
}: {
  dateStart: string;
  dateEnd: string;
}) => {
  const FORMAT_STRING = 'dd-MM-yyyy';

  const currentDate = parse(
    format(new Date(), FORMAT_STRING),
    FORMAT_STRING,
    new Date(),
  );
  const formatStartDate = parse(dateStart, FORMAT_STRING, new Date());
  const formatEndDate = parse(dateEnd, FORMAT_STRING, new Date());

  const IS_VALID_RANGE =
    (isAfter(currentDate, formatStartDate) ||
      isEqual(currentDate, formatStartDate)) &&
    (isBefore(currentDate, formatEndDate) ||
      isEqual(currentDate, formatEndDate));

  return IS_VALID_RANGE;
};
